import React, { useEffect, useRef, createElement } from 'react';
export function SurveyEmbed() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Create script element with the new SurveyMonkey embed code
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.id = 'smcx-sdk';
    script.src = 'https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd6TSw2KGv8z_2BUfWh_2B3S_2BaBh5x0NTZFrSTuEqY33LyIi8.js';
    // Add custom CSS to reduce spacing in SurveyMonkey embed
    const style = document.createElement('style');
    style.textContent = `
      .smcx-embed { padding: 0 !important; }
      .smcx-embed > .smcx-iframe-container { margin: 0 !important; }
      .smcx-embed .smcx-widget { margin-bottom: 0 !important; }
      .smcx-modal-footer { padding: 5px !important; }
      .smcx-modal-footer .progress-bar { margin-bottom: 0 !important; }
      .smcx-modal-footer .btn { margin-left: 20px !important; }
      .smcx-embed, .smcx-modal { background-color: white !important; }
    `;
    document.head.appendChild(style);
    // Add the script to the DOM
    if (containerRef.current) {
      containerRef.current.appendChild(script);
    }
    // Cleanup function to remove the script when component unmounts
    return () => {
      if (containerRef.current && script.parentNode) {
        script.parentNode.removeChild(script);
      }
      document.head.removeChild(style);
    };
  }, []);
  return <div className="w-full flex flex-col bg-white" data-id="element-120">
      <div ref={containerRef} className="w-full min-h-[180px] bg-white" data-id="element-121">
        {/* SurveyMonkey will inject its content here */}
        <div className="text-center py-0 bg-white" data-id="element-122"></div>
      </div>
    </div>;
}